'use strict';

module.exports = /([{}])\1|\{([^}]*)\}|(%)%|(%(\w*))/g;


//////////////////
// WEBPACK FOOTER
// ./node_modules/sugar/common/var/STRING_FORMAT_REG.js
// module id = 614
// module chunks = 0